export default "__VITE_ASSET__ce562f74__"